import { scheduleOnce } from '@ember/runloop';
import { A } from '@ember/array';
import SHSearchField from './sh-search-field';

export default SHSearchField.extend({
  keyupDelay: 750,

  apiCallFunction: undefined,
  searchResults: undefined,
  isLoadingSearchResults: undefined,
  isClosing: undefined,

  actions:  {
    closeButtonAction() {
      this._super(...arguments);
      window.clearTimeout(this.get('keyupTimeout'));

      this.set('searchResults', A());
      this.set('isClosing', true);

      setTimeout(()=> {
        scheduleOnce('afterRender', this, function() {
          this.set('searchResults', undefined);
          this.set('isClosing', false);
        });
      }, 50);
    }
  },

  didInsertElement() {
    this._super(...arguments);

    let self = this;

    let input = this.element.querySelector('input');
    let apiCallFunction = this.get('apiCallFunction');
    let keyupDelay = this.get('keyupDelay');

    input.addEventListener('keyup', function(e) {
      window.clearTimeout(self.get('keyupTimeout'));

      if(input.value.length > 0){
        let timeout = setTimeout(function() {
            self.set('isLoadingSearchResults', true);
            apiCallFunction(input.value).then(results => {
              self.set('searchResults', results);
            }, errorReason => {
              self.set('searchResults', A());
            }).finally(() => {
              self.set('isLoadingSearchResults', false);
            });
        }, keyupDelay);

        self.set('keyupTimeout', timeout);
      } else {
        self.set('searchResults', undefined);
      }
    });
  },

  willDestroy() {
    this._super(...arguments);
    this.set('searchResults', undefined);
    window.clearTimeout(this.get('keyupTimeout'));
  }


});
